"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgFilterOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 32 34",
    stroke: "#17181A",
    strokeLinejoin: "round",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.667 5.96l10.62 9.772v13.27l6.007-2.342V15.732l10.04-9.772V2.331H2.666v3.63z"
  }));
}

var MemoSvgFilterOutlined = /*#__PURE__*/React.memo(SvgFilterOutlined);
var _default = MemoSvgFilterOutlined;
exports["default"] = _default;